// extracted by css-extract-rspack-plugin
export default {"Label":"Label-module__Label__foT2sd7","Icon":"Label-module__Icon__KWDKdc7"};